{
  "en": {
    "qrcodes": {
      "buttons": {
        "generate": "Generate QR Code"
      }
    }
  }
}
